import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const ServicesPage = lazy(() =>
  import("@/admin/pages/ServicesPage").then((m) => ({ default: m.ServicesPage })),
);

export const Route = createFileRoute("/admin/services")({
  component: () => (
    <Suspense fallback={null}>
      <ServicesPage />
    </Suspense>
  ),
});
